import gql from 'graphql-tag';

const GET_SALES_CHANNEL = gql`
query getSalesChannel($filter: SimpleFilterInput) {
  salesChannels(filter: $filter) {
    id
    name
    store
    kind
    bipicking
    bipicking_validation_max_items
    flag_lane
    email_spid
    email_manager
    email_alert
    email_ultravip
    email_rejected_orders
    email_low_fill_rate
    email_low_found_rate
    email_rejected_audits
  }
}`;

export default GET_SALES_CHANNEL;
